/**
 * Per-feature parent link without a closure per feature.
 *
 * Features used to get `part.getParent = () => this` - one closure (+ context) per feature, ~40k of them.
 * Now every feature shares ONE function and keeps a plain `_parent` reference.
 * `getParent` stays an OWN property (not a prototype method) on purpose: lots of code checks
 * `item.getParent ? item.getParent() : item` to tell features/groups from top level parents.
 */
function getParentRef(this: {_parent?: unknown}) {
  return this._parent;
}

export const setFeatureParent = <T extends object>(feature: T, parent: unknown): T => {
  const target = feature as T & {_parent?: unknown; getParent?: () => unknown};
  target._parent = parent;
  target.getParent = getParentRef;
  return feature;
};
